document.addEventListener("DOMContentLoaded", function() {
  const hotspots = document.querySelectorAll(".hotspot-link");

  hotspots.forEach(hotspot => {
    hotspot.addEventListener("click", function(event) {
      event.stopPropagation();
      window.location.href = this.href;
    });
  });
});